import React, { useState, useEffect } from "react"
import { isEqual } from "lodash"

export const useEffectFirstSkip = (func: Function, effect: Array<any>) => {
  // 初回のレンダーでの処理をスキップするuseEffect
  // ここ以外で使用するなら、別の場所に移す
  const [renderCount, setRenderCount] = useState(0)

  useEffect(() => {
    if (!renderCount) return setRenderCount(1)
    func()
    const _renderCount = renderCount + 1
    setRenderCount(_renderCount)
  }, [...effect])
}
